<template>
  <div>
    <div class="nav-pf-vertical vertical-nav">
      <ul class="list-group">
        <router-link tag="li" exact-active-class="active" class="list-group-item" :to="{ name: 'settings.groups.index' }" :class="{active: $route.path.match('settings/groups*')}">
          <a href="#">
            <span class="fa fa-folder" />
            <span class="list-group-item-value">จัดการหน่วยงาน</span>
          </a>
        </router-link>
        <router-link tag="li" exact-active-class="active" class="list-group-item" :to="{ name: 'settings.osda-users.index' }" :class="{active: $route.path.match('settings/osda-users*')}">
          <a href="#">
            <span class="fa fa-users" />
            <span class="list-group-item-value">บัญชีเจ้าหน้าที่ OSDA</span>
          </a>
        </router-link>
      </ul>
    </div>

    <router-view />
  </div>
</template>

<script>
export default {
  mounted () {
    console.log(this.$router)
  }
}
</script>



// WEBPACK FOOTER //
// src/js/views/settings/Layout.vue